import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import { Spacer } from 'design-system';
import { rem } from 'design-system/values';
import SectionHeader from 'design-system/SectionHeader';
import { useAppSelector } from 'store/hooks';
import ActivityItem from './ActivityItem';
import { selectActiveTradingSecclAccounts, selectInitialInvestmentActivity } from '../reducers/selectors';
const InitialInvestmentSection = () => {
    const activity = useAppSelector(selectInitialInvestmentActivity);
    // The activity is only shown when there is exactly one active Seccl account
    const tradingAccountId = useAppSelector(selectActiveTradingSecclAccounts)[0]?.account.id;
    if (!activity)
        return null;
    return (<>
      <SectionHeader horizontalMargins style={staticStyles.sectionHeader}>
        Initial investment
      </SectionHeader>
      <ActivityItem item={activity} tradingAccountId={tradingAccountId} bounceCard/>
      <Spacer h={8}/>
    </>);
};
const staticStyles = StyleSheet.create({
    sectionHeader: {
        paddingTop: rem(16),
    },
});
export default memo(InitialInvestmentSection);
